import React from "react";
import classNames from "classnames";
import menuicon from "assets/images/menu-dots-icon.svg";
import menuhover from "assets/images/menu-dots-hover.svg";
import nonsubscriber from "assets/images/non-subscriber.svg";
import subscriber from "assets/images/subscriber.svg";
import css from "../style.scss";
import PopoverMenu from "../../components/BatchdailerMenu/PopoverMenu";
import { selectUserId, selectProfile, selectPlanDetails, isLegacyAccountPlan } from "data/user/selectors";
import { useDispatch, useSelector } from "react-redux";
import { getCallSettingIntegration, deleteCallSetting, updateCallForwarding } from "data/user/actions";
import CallForward from "../modals/CallForward";
import ConfirmationModal from "../modals/ConfirmationModal";
import ToastNotification from "../../components/ToastNotification";
import SetupPhoneNumber from "../modals/SetupPhoneNumber";
import ReplacePhoneNumber from "../modals/ReplacePhoneNumber";
import { selectCallSettingsLoading, selectCallSettings, selectLeadAutomator, selectTeamMembers, selectTeamMembersLoading } from "data/user/selectors";
import { getStateandAreaIntegration } from "data/user/actions";
import TeamsBatchDailer from "../modals/TeamsBatchDailer";
import LoadablePanel from 'components/hoc/loadable/Panel';
import { withRouter } from "react-router-dom";
import ActivateSubscriptionPopup from "../modals/ActivateSubscription";
import LeaveMessagePopup from "../modals/LeaveMessage";
import { getPlanNameFromDetails, goToLeadAutomatorUpgrade } from "./LeadAutomator";
import { formatPhone } from "../../../data/user/constants";
import { getBrandName } from "utils/brand";

const CallSettingSection = React.forwardRef(({ isOpen: propIsOpen, onClose, onSelect, onClick, index, history }, ref) => {

    const [alertType, setAlertType] = React.useState(null);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const [issetUpCallOpen, setIsSetUpCallOpen] = React.useState(false);
    const [isReplacePhoneNumberModalOpen, setIsReplacePhoneNumberModalOpen] = React.useState(false);

    const [modalType, setModalType] = React.useState(null);
    const [isRemoveModalOpen, setIsRemoveModalOpen] = React.useState(false);
    const [isTeamModalOpen, setIsTeamModalOpen] = React.useState(false);

    const [hoverMenuIndex, setHoverMenuIndex] = React.useState(null);
    const [openMenuIndex, setOpenMenuIndex] = React.useState(null);
    const [selectedCallSettingId, setSelectedCallSettingId] = React.useState(null);
    const [selectedCallSettingForForwarding, setSelectedCallSettingForForwarding] = React.useState(null);
    const [isStopForwardingModalOpen, setIsStopForwardingModalOpen] = React.useState(false);
    const [showToast, setShowToast] = React.useState(false);
    const [toastMessage, setToastMessage] = React.useState("");
    const [toastType, setToastType] = React.useState("success");

    const dispatch = useDispatch();
    const userID = useSelector(selectUserId);
    const callSettings = useSelector(selectCallSettings);
    const selectLeadAutomatorSection = useSelector(selectLeadAutomator)?.toJS();
    const profile = useSelector(selectProfile)?.toJS();
    const isAdmin = !profile?.subUser;
    const planDetails = useSelector(selectPlanDetails)?.toJS();
    const isLegacyAccount = useSelector(isLegacyAccountPlan);

    const teamMembers = useSelector(selectTeamMembers) || [];
    const isLoading = useSelector(selectCallSettingsLoading);

    const phoneNumbersMaxCount = 3;

    const aggregatedCallSettings = (() => {
      if (callSettings && callSettings.length > 0) {
        const aggregatedList = [];
        for (let i = 0; i < phoneNumbersMaxCount; i++) {
          if (callSettings.length > (i * phoneNumbersMaxCount)) {
            aggregatedList.push(callSettings.slice(i * phoneNumbersMaxCount, (i * phoneNumbersMaxCount) + phoneNumbersMaxCount));
          }
        }
        return aggregatedList;
      }
      return callSettings;
    })();

    const teamFullMembers = teamMembers.filter(
        (m) => m.userType === "TEAM_FULL"
    );

    React.useEffect(() => {
        if (userID) {
            dispatch(getCallSettingIntegration(userID));
            dispatch(getStateandAreaIntegration());
        }
    }, [userID, dispatch]);

    // Wrapper function for leaveMessagePopup using dispatch
    const leaveMessagePopup = React.useCallback((options) => {
        dispatch(LeaveMessagePopup.open(options));
    }, [dispatch]);

    const goToLeadAutomator = React.useCallback(() => {
        goToLeadAutomatorUpgrade({
            planDetails,
            isLegacyAccount,
            dispatch,
            history,
            leaveMessagePopup
        });
    }, [planDetails, isLegacyAccount, dispatch, history, leaveMessagePopup]);

    const handleUpgradeNow = () => {
        // Check if user is on trial
        if (planDetails?.trialAvailable) {
            // Trial user - show Activate Subscription modal
            // Pass flag to indicate this is from Call Settings flow and navigation callback
            dispatch(ActivateSubscriptionPopup.open({
                upgradedFromCallSettings: true,
                onNavigate: (path) => {
                    history.push(path);
                }
            }));
        } else {
            // Regular user (non Lead Automator subscriber) - show Lead Automator upgrade
            goToLeadAutomator();
        }
    };

    const handlesetUpcall = () => {
        setIsModalOpen(true);
    };

    const handleUpCallOpen = () => {
        setIsSetUpCallOpen(true);
    };


    const handleCloseTeamModal = () => {
        setIsTeamModalOpen(false);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleCloseSetup = () => {
        setIsSetUpCallOpen(false);
        setIsReplacePhoneNumberModalOpen(false);
    };

    const handleReplaceClick = (callSettingId) => {
        setAlertType("replace");
        setSelectedCallSettingId(callSettingId);
        setIsRemoveModalOpen(true);
    };

    const handleDeleteClick = (callSettingId) => {
        setAlertType("delete");
        setSelectedCallSettingId(callSettingId);
        setIsRemoveModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
      try {
            const result = await dispatch(deleteCallSetting(userID));
            if (result && result.success) {
                setToastMessage("You numbers have been successfully deleted.");
                setToastType("success");
                setShowToast(true);
                setIsRemoveModalOpen(false);
                setSelectedCallSettingId(null);
                setTimeout(() => setShowToast(false), 2000);
            } else {
                setToastMessage("Something went wrong. Please try again.");
                setToastType("error");
                setShowToast(true);
                setIsRemoveModalOpen(false);
                setSelectedCallSettingId(null);
                setTimeout(() => setShowToast(false), 3000);
            }
        } catch (err) {
            setToastMessage("Something went wrong. Please try again.");
            setToastType("error");
            setShowToast(true);
            setIsRemoveModalOpen(false);
            setSelectedCallSettingId(null);
            setTimeout(() => setShowToast(false), 3000);
        }
    };

    const handleReplaceConfirm = async () => {
        setIsReplacePhoneNumberModalOpen(true);
        setIsRemoveModalOpen(false);
    };

    const handleChangeForwardingClick = (callSettingId, currentForwardingNumber) => {
        setSelectedCallSettingForForwarding({ id: callSettingId, forwardingNumber: currentForwardingNumber });
        setModalType("change");
        setIsModalOpen(true);
    };

    const handleStopForwardingClick = (callSettingId) => {
        setSelectedCallSettingId(callSettingId);
        setIsStopForwardingModalOpen(true);
    };

    const handleStopForwardingConfirm = async () => {
        try {
            const result = await dispatch(updateCallForwarding(selectedCallSettingId, null, userID));
            if (result && result.success) {
                setToastMessage("Your call forwarding has been successfully stopped.");
                setToastType("success");
                setShowToast(true);
                setIsStopForwardingModalOpen(false);
                setSelectedCallSettingId(null);
                setTimeout(() => setShowToast(false), 2000);
            } else {
                setToastMessage("Something went wrong. Please try again.");
                setToastType("error");
                setShowToast(true);
                setIsStopForwardingModalOpen(false);
                setSelectedCallSettingId(null);
                setTimeout(() => setShowToast(false), 3000);
            }
        } catch (err) {
            setToastMessage("Something went wrong. Please try again.");
            setToastType("error");
            setShowToast(true);
            setIsStopForwardingModalOpen(false);
            setSelectedCallSettingId(null);
            setTimeout(() => setShowToast(false), 3000);
        }
    };

    const getOutboundPhoneNumberMenuItems = (callSettingId) => {
        const items = [
            { label: "Replace Phone Numbers", onClick: () => handleReplaceClick(callSettingId) }
        ];
        // Only show delete option for admins
        if (isAdmin) {
            items.push({ label: "Delete Phone Numbers", onClick: () => handleDeleteClick(callSettingId) });
        }
        return items;
    };

    const getForwardingMenuItems = (callSettingId, forwardingNumber) => {
        return [
            { label: "Change Forwarding Number", onClick: () => handleChangeForwardingClick(callSettingId, forwardingNumber) },
            { label: "Stop Call Forwarding", onClick: () => handleStopForwardingClick(callSettingId) }
        ];
    };

    const ThreeDotsMenu = ({ index, rowType, menuItems, customWidth }) => {
        const isHovered = hoverMenuIndex === `${index}-${rowType}`;
        const isOpen = openMenuIndex === `${index}-${rowType}`;
        return (
            <div
                className={classNames(css.menuIconWrapper, {
                    [css.activeMenu]: isOpen
                })}
                onMouseEnter={() => !isOpen && setHoverMenuIndex(`${index}-${rowType}`)}
                onMouseLeave={() => setHoverMenuIndex(null)}
                onClick={() => {
                    setOpenMenuIndex(prev =>
                        prev === `${index}-${rowType}` ? null : `${index}-${rowType}`
                    );
                }}
            >
                <img
                    src={isOpen ? menuhover : menuicon}
                    alt="menu-icon"
                    className={css.menuIcon}
                />

                {isOpen && (
                    <PopoverMenu
                        isOpen={true}
                        onClose={() => setOpenMenuIndex(null)}
                        items={menuItems}
                        position="right"
                        className={css.callSettingsMenu}
                        customWidth={customWidth}
                    />
                )}
            </div>
        );
    };

    const handleEditTeamPermissions = () => {
        setIsTeamModalOpen(true);
    };

    return (
        <div className={classNames(css.clsCard, css.clsNewCallSettingSection)}>
            <LoadablePanel isLoading={isLoading} >
                <div className={classNames(css.clsCardHeader, css.d_flex, css.align_items_center, css.justify_content_between)} >
                    <h4 className={classNames(css.clsCardTitle)}>Call Settings</h4>
                    {selectLeadAutomatorSection?.accountPlanMrcs?.length ? (
                        teamFullMembers.length > 0 && callSettings?.length > 0 && (
                            <div
                                className={css.editPermissionContainer}
                                onClick={handleEditTeamPermissions}
                            >
                                <span className={css.clsEditPermission}>Edit Team Permissions</span>
                            </div>
                        )
                    ) : (
                            <div className={css.clsPhoneCall} onClick={handleUpgradeNow}>
                                <span>Upgrade Now</span>
                            </div>
                        
                    )}
                    {callSettings.length === 0 &&
                        selectLeadAutomatorSection?.accountPlanMrcs?.length > 0 && (
                            <span
                                type="button"
                                className={css.clsSetUpCall}
                                onClick={handleUpCallOpen}
                            >
                                Setup Phone Numbers
                            </span>
                        )}
                </div>
                {selectLeadAutomatorSection &&
                    selectLeadAutomatorSection.accountPlanMrcs &&
                    selectLeadAutomatorSection.accountPlanMrcs.length ? (
                    <div >
                        {callSettings?.length === 0 ? (
                            <div className={css.clsCallCard}>
                                <div className={css.clsSubcriberSection}>
                                    <div><img src={subscriber} alt="subscriber" /></div>
                                    <div className={css.subscriberContent}>
                                        <div className={css.subscriberTitle}>
                                            <span>Make Calls Inside<br />{getBrandName()} Today!</span>
                                        </div>

                                        <div className={css.upgradeBtnWrapper} onClick={handleUpCallOpen}>
                                            <button className={css.upgradeBtn}><span className={css.upgradeBtnTxt}>Setup Phone Numbers</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        ) : (
                            aggregatedCallSettings?.map((item, index) => {
                                const days = item[0]?.daysUntilReplaceable || 0;
                                const hasForwarding = !!item[0]?.forwardingNumber;
                                const moreThan7 = days === 0 || days > 7;

                                return (
                                    <React.Fragment key={index}>
                                        {/* PHONE NUMBER ROW */}
                                        <div className={css.clsCallContainer}>
                                            <div className={css.phoenumberRow}>
                                                <span className={css.phonelabel}>Your Numbers</span>
                                                <span className={classNames(css.batchTxt, css.batchTxtCallSettings)}>{item.map((callSettingItem) => formatPhone(callSettingItem.outboundNumber)).join(", ")}</span>
                                            </div>

                                            <div className={css.rightSide}>
                                                {moreThan7 ? (
                                                    <ThreeDotsMenu
                                                        index={index}
                                                        rowType="phone"
                                                        menuItems={getOutboundPhoneNumberMenuItems(item[0]?.id)}
                                                    />
                                                ) : (
                                                    <div className={css.numberReplace}>
                                                        <span>Replaceable in {days} Days</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* CALL FORWARDING ROW */}
                                        <div className={css.clsForwardContainer}>
                                            <div className={css.phoenumberRow}>
                                                <span className={css.phonelabel}>Call forwarding number</span>
                                                <span className={css.batchTxt}>{hasForwarding ? formatPhone(item[0]?.forwardingNumber) : "None"}</span>
                                            </div>
                                            <div className={css.rightSide}>
                                                {moreThan7 ? (
                                                    hasForwarding ? (
                                                        // >7 + has forwarding
                                                        <ThreeDotsMenu
                                                            index={index}
                                                            rowType="forward"
                                                            menuItems={getForwardingMenuItems(item[0]?.id, item[0]?.forwardingNumber)}
                                                            customWidth={258}
                                                        />
                                                    ) : (
                                                        // >7 + no forwarding
                                                        <div className={css.setupCall} onClick={() => {
                                                            setSelectedCallSettingForForwarding({ id: item[0]?.id });
                                                            setModalType("setup");
                                                            setIsModalOpen(true);
                                                        }}>
                                                            <span>Setup Call Forwarding</span>
                                                        </div>
                                                    )
                                                ) : (
                                                    hasForwarding ? (
                                                        // <=7 + has forwarding
                                                        <ThreeDotsMenu
                                                            index={index}
                                                            rowType="forward"
                                                            menuItems={getForwardingMenuItems(item[0]?.id, item[0]?.forwardingNumber)}
                                                            customWidth={258}
                                                        />
                                                    ) : (
                                                        // <=7 + no forwarding
                                                        <div className={css.setupCall} onClick={() => {
                                                            setSelectedCallSettingForForwarding({ id: item[0]?.id });
                                                            setModalType("setup");
                                                            setIsModalOpen(true);
                                                        }}>
                                                            <span>Setup Call Forwarding</span>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </React.Fragment>
                                );
                            })
                        )}
                    </div>
                ) : (
                    <div className={css.clsCallCard}>
                        <div className={css.clsSubcriberSection}>
                            <div><img src={nonsubscriber} alt="nonsubscriber" /></div>
                            <div className={css.nonsubscriberContent}>
                                <div className={css.nonsubscriberTitle}>
                                    <span>Make Calls Inside<br />{getBrandName()} Today!</span>
                                </div>
                                <span className={css.subscriberText}>
                                    Click to Dial is part of our Lead Automator subscription. Upgrade your plan to start making calls directly from {getBrandName()} and streamline your lead outreach.
                                </span>
                                <span
                                    className={classNames(css.learnMore, css.noGap)}
                                    onClick={() => window.open("https://www.propstream.com/lead-automator", "_blank")}
                                    style={{ cursor: "pointer" }}
                                >
                                    Learn more
                                </span>
                                    <div className={css.upgradeBtnWrapper}>
                                        <button className={css.upgradeBtn}><span className={css.upgradeBtnTxt} onClick={handleUpgradeNow}>Upgrade Now</span></button>
                                    </div>
                            </div>
                        </div>
                    </div>
                )}
            </LoadablePanel>
            <CallForward
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                modalType={modalType}
                callSettingId={selectedCallSettingForForwarding?.id}
                currentForwardingNumber={selectedCallSettingForForwarding?.forwardingNumber}
                userID={userID}
            />
            <ConfirmationModal
                isOpen={isStopForwardingModalOpen}
                onClose={() => {
                    setIsStopForwardingModalOpen(false);
                    setSelectedCallSettingId(null);
                }}
                title="Stop Call Forwarding?"
                message={
                    <>
                        Are you sure you want to stop call forwarding?<br />
                        This will also delete your call forwarding number<br />
                        on file.
                    </>
                }
                confirmLabel="Stop"
                cancelLabel="Cancel"
                onConfirm={handleStopForwardingConfirm}
                isDanger={true}
            />
            <SetupPhoneNumber
                isOpen={issetUpCallOpen}
                onClose={handleCloseSetup}
            />
            <ReplacePhoneNumber
                isOpen={isReplacePhoneNumberModalOpen}
                onClose={() => {
                    handleCloseSetup();
                    setSelectedCallSettingId(null);
                }}
                callSettingsId={selectedCallSettingId}
            />
            <ConfirmationModal
                isOpen={isRemoveModalOpen}
                onClose={() => {
                    setIsRemoveModalOpen(false);
                    setSelectedCallSettingId(null);
                }}
                title={alertType === "replace" ? "Replace Phone Numbers?" : "Delete Phone Numbers?"}
                message={
                    alertType === "replace" ? (
                        <>
                            Are you sure you want to replace these phone <br />
                            numbers? You can only replace them once every 7 <br />
                            days.
                        </>
                    ) : (
                        <>
                            Are you sure you want to delete your phone numbers? Call <br />
                            forwarding will be stopped, and <strong>Click to Dial will become</strong><br />
                            <strong>unavailable</strong> until new phone numbers are setup.
                        </>
                    )
                }
                confirmLabel={alertType === "replace" ? "Yes" : "Delete"}
                cancelLabel="Cancel"
                onConfirm={alertType === "replace" ? handleReplaceConfirm : handleDeleteConfirm}
                isDanger={alertType === "delete"}
            />
            {showToast && (
                <ToastNotification
                    message={toastMessage}
                    show={true}
                    type={toastType}
                />
            )}
            <div className={css.clsIntegrationCard}>
                <TeamsBatchDailer
                    isOpen={isTeamModalOpen}
                    onClose={handleCloseTeamModal}
                    modalType="team"
                    clicktoDial={true}
                />
            </div>
        </div >
    );
});

export default withRouter(CallSettingSection);
